export const PreferredInitialRoutes = [
    'EP_Home',
    'STC_Home',
    'Community_Home',
];
export const InitialRouteName = 'EP_Home';
export const FallbackRouteName = 'EP_Home';
// export const InitialRouteName: keyof RootTabParamList = 'STC_Home';
// export const FallbackRouteName: keyof RootTabParamList = 'STC_Home';
